import * as React from 'react'
import { CheckCircle } from 'react-feather'

import Form from 'main/components/common/Form'
import { Button, RadioGroup, Small, Strong, Text } from 'main/ui'
import segment from 'util/analytics/segment'
import { DetailedPricingModal_school } from '../../gql'
import { PricingLevel } from './types'

import { ConfirmationContainer, Container, SmallContainer } from './PricingFeedbackForm.styles'

const PRICING_LEVEL_HIGH: PricingLevel = 'higher than average'
const PRICING_LEVEL_AVG: PricingLevel = 'average'
const PRICING_LEVEL_LOW: PricingLevel = 'lower than average'

const PRICING_LEVEL_OPTIONS = [
  { value: PRICING_LEVEL_HIGH, label: 'Higher' },
  { value: PRICING_LEVEL_AVG, label: 'About the same' },
  { value: PRICING_LEVEL_LOW, label: 'Lower' },
]

interface IProps {
  school: DetailedPricingModal_school
}

export default function PricingFeedbackForm(props: IProps) {
  const { school } = props

  const [selectedPricingLevel, setSelectedPricingLevel] = React.useState<string>('')
  const [submitted, setSubmitted] = React.useState<boolean>(false)

  const handleSubmit = () => {
    const data = {
      pricingLevel: selectedPricingLevel,
      school: school.shortname,
      schoolId: school.id,
    }

    segment.track('School Page Pricing Feedback', data)
    setSubmitted(true)
  }

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Strong muted={submitted}>Share your opinion:</Strong>
        <RadioGroup
          disabled={submitted}
          label={
            <Text muted={submitted}>
              How do these prices compare to similar child care programs in your area?
            </Text>
          }
          options={PRICING_LEVEL_OPTIONS}
          value={selectedPricingLevel}
          onChange={setSelectedPricingLevel}
        />
        <SmallContainer>
          <Small muted={submitted}>
            While prices are generally non-negotiable, we value feedback from our community.
          </Small>
        </SmallContainer>
        {submitted ? (
          <ConfirmationContainer>
            <CheckCircle />
            <Text>Thanks for your feedback!</Text>
          </ConfirmationContainer>
        ) : (
          <Button full disabled={selectedPricingLevel === ''}>
            Send feedback
          </Button>
        )}
      </Form>
    </Container>
  )
}
